import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/gopath/src/github.com/rumblefrog/source-chat-relay/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "service"
    }}>{`Service`}</h1>
    <p>{`For ease of use, a service controller has been baked in to integrate with your system`}</p>
    <h2 {...{
      "id": "installing-and-starting-the-service"
    }}>{`Installing and starting the service`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`./server -config /path/to/config.toml -service install
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`./server -service start
`}</code></pre>
    <h2 {...{
      "id": "checking-service-status"
    }}>{`Checking service status`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`./server -service status
`}</code></pre>
    <h2 {...{
      "id": "stopping-service"
    }}>{`Stopping service`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`./server -service stop
`}</code></pre>
    <h2 {...{
      "id": "restarting-service"
    }}>{`Restarting service`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`./server -service restart
`}</code></pre>
    <h2 {...{
      "id": "uninstalling-service"
    }}>{`Uninstalling service`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`./server -service uninstall
`}</code></pre>
    <h2 {...{
      "id": "all-the-possible-control-via-service"
    }}>{`All the possible control via service`}</h2>
    <ul>
      <li parentName="ul">{`status`}</li>
      <li parentName="ul">{`start`}</li>
      <li parentName="ul">{`stop`}</li>
      <li parentName="ul">{`restart`}</li>
      <li parentName="ul">{`install`}</li>
      <li parentName="ul">{`uninstall`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      